module.exports = __webpack_public_path__ + "fonts/MavenPro-Bold.24bce232.ttf";